import data from './data'
import methods from './methods'

export default {
  data,
  methods
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/change-password/resources/index.js